import React from 'react';
import { Box, Grid, Paper, Slide, Typography } from '@material-ui/core';
import pizza from '../../static/images/pizza.jpg';
import useStyles from './Home.css';

const Home = (): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid container component="main" className={classes.root}>
      <Slide in direction="right">
        <Grid
          item
          xs={12}
          style={{ backgroundImage: `url(${pizza})` }}
          sm={4}
          md={7}
          className={classes.image}
        />
      </Slide>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box display="flex" height="100%" flexDirection="column">
          <Box
            p={8}
            m={[4, 3, 8]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Box>
              <Typography variant="h6" color="primary" gutterBottom>
                &ldquo;WAS IM CCG MEETINGPOINT SCHMECKT, SCHMECKT AUCH AM
                ARBEITSPLATZ ODER ZUHAUSE&rdquo;
              </Typography>
              <Typography variant="body2" color="textPrimary">
                Die Besonderheiten der einzelnen Büros und Hallen hinsichtlich
                der Versorgung liegen uns am Herzen — wir bemühen uns und bitten
                dafür um das direkte und aktive Gespräch.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Home;
